import { cn } from "lib/utils";
import React from "react";

import welcomeBackground from "assets/images/totem/welcome-background.png";
import { ActionButton } from "../ActionButton";
import { TotemHeader } from "../TotemHeader";

export const WelcomeScreen: React.FC<{ onStart: () => void }> = ({
	onStart,
}) => (
	<main
		className={cn(
			"mx-auto flex min-h-full w-full max-w-[800px] flex-col items-center gap-14 bg-white px-6 pb-14 pt-8 max-[1023px]:px-5 max-[1023px]:pb-10 max-[1023px]:pt-6 max-[639px]:gap-8 max-[639px]:px-3 max-[639px]:pb-8 max-[639px]:pt-4",
		)}
	>
		<section
			className={cn(
				"relative h-[924px] w-full shrink-0 max-[639px]:h-[620px]",
			)}
		>
			<div
				className={cn(
					"absolute left-0 top-[50px] h-[832px] w-full overflow-hidden max-[1023px]:top-[44px] max-[1023px]:h-[680px] max-[639px]:top-[36px] max-[639px]:h-[430px]",
				)}
			>
				<img
					src={welcomeBackground}
					alt="Motorista no caminhão"
					className={cn(
						"absolute inset-0 h-full w-full object-cover",
					)}
				/>
				<div className={cn("absolute inset-0 bg-white/20")} />
			</div>
			<TotemHeader />
			<div
				className={cn(
					"absolute left-1/2 top-[740px] flex w-[600px] max-w-full -translate-x-1/2 flex-col items-start gap-[10px] bg-white px-12 py-8 max-[1023px]:top-[610px] max-[1023px]:px-8 max-[1023px]:py-6 max-[639px]:top-[430px] max-[639px]:w-[80%] max-[639px]:px-6 max-[639px]:py-5",
				)}
			>
				<h1
					className={cn(
						"font-sans text-[32px] font-bold leading-normal text-[#1D293D] max-[639px]:text-[24px]",
					)}
				>
					Pronto para começar?
				</h1>
				<p
					className={cn(
						"font-sans text-[24px] leading-normal text-[#45556C] max-[639px]:text-[17px]",
					)}
				>
					Tenha em mãos a placa do veículo ou o CPF do motorista.
				</p>
			</div>
		</section>
		<ActionButton onClick={onStart}>Iniciar check-in</ActionButton>
		<p
			className={cn(
				"w-full text-center font-sans text-[32px] leading-normal text-[#62748E] max-[639px]:text-[18px]",
			)}
		>
			Precisa de ajuda? Procure a portaria.
		</p>
	</main>
);
